<template>
  <!-- [sc-48951] Tipologia e unità di vendita si contraddicono: lo si dice, e
       si propone l'unità giusta. Il campo lo cambia solo il clic, mai il
       modulo da solo (sc-48350 / task 48396). -->
  <div v-if="avviso" class="unita-avviso" role="status">
    <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
    <p class="unita-avviso__testo">
      «{{ avviso.tipologia }}» si vende di solito a
      <strong>{{ avviso.etichettaAttesa }}</strong
      >, ma l'unità di vendita è <strong>{{ avviso.etichettaScelta }}</strong
      >: il preventivo lo fatturerà così, e chiederà i dati per scatola di
      quell'unità.
      <template v-if="!avviso.disponibile">
        {{ avviso.etichettaAttesa }} non è fra le unità dell'azienda.
      </template>
    </p>
    <button
      v-if="avviso.disponibile"
      type="button"
      class="unita-avviso__usa"
      @click="$emit('usa', avviso.attesa)"
    >
      Usa {{ avviso.etichettaAttesa }}
    </button>
  </div>
</template>

<script>
import { avvisoUnitaTipologia } from "@/config/itemFields";

export default {
  name: "UnitaTipologiaAvviso",
  props: {
    category: { type: String, default: "" },
    subCategory: { type: String, default: "" },
    salesUnit: { type: String, default: "" },
    opzioni: { type: Array, default: () => [] },
  },
  emits: ["usa"],
  computed: {
    avviso() {
      return avvisoUnitaTipologia({
        category: this.category,
        subCategory: this.subCategory,
        salesUnit: this.salesUnit,
        opzioni: this.opzioni,
      });
    },
  },
};
</script>

<style scoped>
.unita-avviso {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 4px 0 16px;
  padding: 10px 14px;
  border: 0.5px solid #f59e0b;
  border-radius: 8px;
  background: #fffbeb;
  color: #78350f;
  font-size: 14px;
}

.unita-avviso__testo {
  flex: 1;
  margin: 0;
}

.unita-avviso__usa {
  flex-shrink: 0;
  padding: 6px 12px;
  border: 0.5px solid #b45309;
  border-radius: 8px;
  background: #ffffff;
  color: #78350f;
  font-weight: 600;
  cursor: pointer;
}

.unita-avviso__usa:hover {
  background: #fef3c7;
}

@media (max-width: 720px) {
  .unita-avviso {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
